export const formatTenancyLength = (weeks, days) => {
  if (weeks === undefined && days === undefined) {
    return '';
  }

  let str = '';
  let needTrim = false;

  if (!isNaN(weeks) && weeks >= 1) {
    str += `${Math.floor(weeks)} Weeks`;
  } else {
    needTrim = true;
  }

  if (!isNaN(days) && days > 0 && days % 7) {
    str += ` ${days % 7} Days`;
  }

  if (needTrim) {
    str = str.trim();
  }

  return str;
};
